import React, { PropsWithChildren } from 'react';
import styles from './SmallModal.module.scss';
import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import LiteralsService from 'src/services/literals/LiteralsService';
import { SmallModalModel } from 'src/types/view-models/small-modal.view.model';
import { ButtonPrimary, ButtonSecondary, Modal, ModalBody, ModalFooter, ModalHeader } from '@americanexpress/dls-react';
import Selectors from 'src/utils/selectors';

export default function SmallModal({
    onClose,
    headerText,
    onSubmit,
    id,
    'data-cy': dataCy,
    children,
    submitButtonText
}: PropsWithChildren<SmallModalModel>): JSX.Element {
    return (
        // Override DLS
        // Have to use aria-labelledby instead of aria-label because of a quirk in dls-react
        <Modal aria-labelledby={`${id}-header`} id={id} className={styles.smallModal} data-cy={dataCy}>
            <ModalHeader onClose={onClose} id={`${id}-header`}>
                <Typography className={styles.modalHeader} variant={TypographyVariants.HEADING_M}>
                    {headerText}
                </Typography>
            </ModalHeader>
            <ModalBody className={styles.modalBody}>{children}</ModalBody>
            <ModalFooter className={styles.modalFooter}>
                <div className="full-width bottom-buttons">
                    <ButtonSecondary data-cy={Selectors.SpendSmart.CLOSE_BUTTON} onClick={onClose}>
                        {LiteralsService.getLiteral('CommonText.cancel')}
                    </ButtonSecondary>
                    <ButtonPrimary data-cy={Selectors.General.SUBMIT_BUTTON} onClick={onSubmit}>
                        {submitButtonText || LiteralsService.getLiteral('CommonText.yes')}
                    </ButtonPrimary>
                </div>
            </ModalFooter>
        </Modal>
    );
}
